import React, { useEffect, useState } from 'react';
import { ReactComponent as CheckMark } from '../../assets/svg/checkmark.svg';
import { DropdownItem } from '../Shared/DropdownItem';
import { Option } from '../../models/SelectInputs';
import { JobType } from '../../models/JobType';

interface Props {
    styles: any;
    jobTypes: JobType[];  
    selectOption(jobTypeId: number): void;
}

export const JobTypeSelect: React.FC<Props> = (props) => {
    const styles = props.styles;
    const [options, setOptions] = useState<Option[]>([]);
    const [hoveredIndex, setHoveredIndex] = useState<number>(-1);

    useEffect(() => {
        generateJobTypeOptions();
    }, [props.jobTypes])

    const generateJobTypeOptions = () => {
        let tempOptions: Option[] = [];
        props.jobTypes.forEach((jobType) => {
            let option: Option = {
                value: jobType.jobTypeId,
                option: jobType.jobTypeName,
                checked: jobType.isSelected
            }
            tempOptions.push(option);
        })
        tempOptions.sort((a, b) => a.option.localeCompare(b.option));
        setOptions(tempOptions);
    }

    return (
        <div style={styles.wrapper}>
            <div className="scrollArea optionSelectScroll" style={styles.scrollArea}>
                {options.map((option, index) =>
                    <div
                        key={index}
                        onMouseEnter={() => { setHoveredIndex(index); }}
                        onMouseLeave={() => { setHoveredIndex(-1); }}
                    >
                        <DropdownItem key={index} styles={styles.option} onClick={() => props.selectOption((option.value as number))}>
                            {option.checked ? <CheckMark style={styles.checkMark} />
                                : <div style={styles.checkbox}></div>}
                            <label style={styles.optionLabel}>{option.option}</label>
                        </DropdownItem>
                        <hr style={{ ...styles.bottomBorder, ...((hoveredIndex === index || hoveredIndex === index + 1 || options.length === index + 1) && styles.hoveredBorder) }} />
                    </div>
                )}
            </div>
        </div>
    )
}

